import { useState, useEffect, ReactNode } from 'react'
import { useTranslation } from 'react-i18next';
import { PageTitleBar } from './layout/PageBar';
import { APIRequestGet } from '../utils/APIRequests';
import { UserEmailListSchema } from '../api/Admin';

function Users(): ReactNode {
    const { t } = useTranslation(['nav_menu']);
    const [users, setUsers] = useState<string[]>([]);

    useEffect(() => {
        getAllUsers();

        console.log("users mount");
        return () => {
            console.log("users unmount");
        };
    }, []);

    function getAllUsers(): void {
        APIRequestGet('/admin/getAllUsers', {
            schema: UserEmailListSchema,
            logSuccess: true
        }).then((result) => {
            setUsers(result.data.users);
        });
    }

    return (
        <>
            <PageTitleBar title={t('users')} />
            <div className='max-width text-page-padding users-list'>
                {users.map(user =>
                    <div className='users-list-item' key={user}>
                        {user}
                    </div>
                )}
            </div>
        </>

    )
}

export default Users;